import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

const firebaseConfig = {
	apiKey: "AIzaSyBt9POyxjvJuzA1BFs3wCXFdZ59QSVrzfg",
	authDomain: "bharatham-23.firebaseapp.com",
	projectId: "bharatham-23",
	storageBucket: "bharatham-23.appspot.com",
	messagingSenderId: "158322692736",
	appId: "1:158322692736:web:016749f4b50696cd704c65",
	measurementId: "G-BD0746RY77"
};

const app = firebase.initializeApp(firebaseConfig);

var auth = firebase.auth();
var provider = new firebase.auth.GoogleAuthProvider();
export {auth , app, provider};